import styled from 'styled-components'

export const StyledIconSvgFromServer = styled.span<{ height: number }>`
  color: ${(p) => p.theme.colors.default.primary[90]};

  svg {
    height: ${(p) => p.height}px;
  }
`
